export default __webpack_public_path__ + "static/media/nft6.0d4a5079.jpg";